// extracted by mini-css-extract-plugin
export default {"pill":"StatusPill_pill__-J-EQ","label":"StatusPill_label__Y7K+P"};